import { create } from 'zustand';

export interface Toast {
  id: number;
  message: string;
  tone: 'info' | 'success' | 'error';
  action?: { label: string; onClick: () => void };
}

export const useToasts = create<{ toasts: Toast[] }>(() => ({ toasts: [] }));

let nextId = 1;

export function dismissToast(id: number): void {
  useToasts.setState((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
}

export function toast(
  message: string,
  options: { tone?: Toast['tone']; action?: Toast['action']; duration?: number } = {},
): number {
  const id = nextId++;
  const item: Toast = { id, message, tone: options.tone ?? 'info', action: options.action };
  useToasts.setState((s) => ({ toasts: [...s.toasts.slice(-3), item] }));
  const duration = options.duration ?? (options.action ? 6000 : 3500);
  if (duration > 0) window.setTimeout(() => dismissToast(id), duration);
  return id;
}
